import { State } from 'src/types'

export const pitcherDesign = (ctx: CanvasRenderingContext2D, state: State, x: number, y: number, numerator?: number, scaleSize?: number): void => {
  if (numerator !== undefined && scaleSize !== undefined) {
    ctx.save()
    ctx.rotate((numerator * Math.PI) / 180)
    ctx.scale(scaleSize, scaleSize)
  }

  //// ラベル左の大きいデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(471 + x, 501 + y)
  ctx.quadraticCurveTo(437 + x, 522 + y, 429 + x, 544 + y)
  ctx.quadraticCurveTo(423 + x, 567 + y, 430 + x, 575 + y)
  ctx.quadraticCurveTo(438 + x, 587 + y, 452 + x, 579 + y)
  ctx.quadraticCurveTo(472 + x, 569 + y, 472 + x, 567 + y) // 右端
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(471 + x, 504 + y)
  ctx.quadraticCurveTo(437 + x, 525 + y, 429 + x, 548 + y)
  ctx.quadraticCurveTo(425 + x, 571 + y, 433 + x, 578 + y)
  ctx.quadraticCurveTo(438 + x, 587 + y, 452 + x, 579 + y)
  ctx.quadraticCurveTo(472 + x, 569 + y, 472 + x, 567 + y) // 右端
  ctx.quadraticCurveTo(454 + x, 571 + y, 447 + x, 555 + y)
  ctx.quadraticCurveTo(443 + x, 538 + y, 455 + x, 527 + y)
  ctx.quadraticCurveTo(461 + x, 517 + y, 474 + x, 511 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(469 + x, 498 + y)
  ctx.quadraticCurveTo(449 + x, 509 + y, 437 + x, 522 + y)
  ctx.quadraticCurveTo(427 + x, 536 + y, 423 + x, 557 + y)
  ctx.quadraticCurveTo(423 + x, 578 + y, 436 + x, 587 + y)
  ctx.quadraticCurveTo(440 + x, 593 + y, 457 + x, 582 + y)
  ctx.quadraticCurveTo(490 + x, 559 + y, 490 + x, 559 + y)
  ctx.quadraticCurveTo(472 + x, 564 + y, 459 + x, 563 + y)
  ctx.quadraticCurveTo(452 + x, 559 + y, 449 + x, 551 + y)
  ctx.quadraticCurveTo(451 + x, 529 + y, 476 + x, 512 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  //// ラベル左下のデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(531 + x, 532 + y)
  ctx.quadraticCurveTo(538 + x, 542 + y, 508 + x, 574 + y)
  ctx.quadraticCurveTo(533 + x, 569 + y, 548 + x, 544 + y)
  ctx.quadraticCurveTo(555 + x, 524 + y, 548 + x, 510 + y)
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(534 + x, 533 + y)
  ctx.quadraticCurveTo(533 + x, 551 + y, 512 + x, 572 + y)
  ctx.quadraticCurveTo(527 + x, 566 + y, 541 + x, 552 + y)
  ctx.quadraticCurveTo(554 + x, 537 + y, 548 + x, 514 + y)
  ctx.quadraticCurveTo(534 + x, 533 + y, 534 + x, 533 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(520 + x, 552 + y)
  ctx.quadraticCurveTo(510 + x, 568 + y, 498 + x, 580 + y)
  ctx.quadraticCurveTo(526 + x, 579 + y, 545 + x, 558 + y)
  ctx.quadraticCurveTo(564 + x, 532 + y, 552 + x, 506 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  //// ラベル右下のデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(557 + x, 502 + y)
  ctx.quadraticCurveTo(572 + x, 507 + y, 580 + x, 499 + y)
  ctx.quadraticCurveTo(586 + x, 485 + y, 578 + x, 481 + y)
  ctx.quadraticCurveTo(580 + x, 492 + y, 560 + x, 494 + y)
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(557 + x, 501 + y)
  ctx.quadraticCurveTo(570 + x, 505 + y, 578 + x, 498 + y)
  ctx.quadraticCurveTo(583 + x, 489 + y, 579 + x, 484 + y)
  ctx.quadraticCurveTo(580 + x, 492 + y, 560 + x, 496 + y)
  ctx.quadraticCurveTo(557 + x, 501 + y, 557 + x, 501 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(553 + x, 505 + y)
  ctx.quadraticCurveTo(568 + x, 513 + y, 578 + x, 504 + y)
  ctx.quadraticCurveTo(587 + x, 495 + y, 584 + x, 483 + y)
  ctx.quadraticCurveTo(580 + x, 475 + y, 574 + x, 474 + y)
  ctx.moveTo(565 + x, 488 + y)
  ctx.quadraticCurveTo(579 + x, 486 + y, 572 + x, 477 + y)

  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  //   // ラベル右のデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(571 + x, 452 + y)
  ctx.quadraticCurveTo(589 + x, 438 + y, 589 + x, 422 + y)
  ctx.quadraticCurveTo(585 + x, 411 + y, 572 + x, 416 + y)
  ctx.quadraticCurveTo(556 + x, 430 + y, 556 + x, 430 + y) // 先端
  ctx.quadraticCurveTo(567 + x, 423 + y, 574 + x, 428 + y)
  ctx.quadraticCurveTo(575 + x, 435 + y, 561 + x, 445 + y)
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(569 + x, 452 + y)
  ctx.quadraticCurveTo(589 + x, 438 + y, 587 + x, 424 + y)
  ctx.quadraticCurveTo(585 + x, 412 + y, 572 + x, 419 + y)
  ctx.quadraticCurveTo(556 + x, 430 + y, 556 + x, 430 + y) // 先端
  ctx.quadraticCurveTo(567 + x, 422 + y, 574 + x, 427 + y)
  ctx.quadraticCurveTo(577 + x, 435 + y, 564 + x, 445 + y)
  ctx.quadraticCurveTo(563 + x, 453 + y, 563 + x, 453 + y)
  ctx.quadraticCurveTo(569 + x, 452 + y, 569 + x, 452 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(579 + x, 451 + y)
  ctx.quadraticCurveTo(599 + x, 432 + y, 593 + x, 422 + y)
  ctx.quadraticCurveTo(588 + x, 406 + y, 568 + x, 415 + y)
  ctx.quadraticCurveTo(554 + x, 423 + y, 549 + x, 436 + y)
  ctx.quadraticCurveTo(560 + x, 427 + y, 567 + x, 430 + y)
  ctx.quadraticCurveTo(575 + x, 427 + y, 560 + x, 444 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  //   // ラベル右上のデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(494 + x, 449 + y)
  ctx.quadraticCurveTo(507 + x, 441 + y, 522 + x, 458 + y)
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(494 + x, 451 + y)
  ctx.quadraticCurveTo(507 + x, 441 + y, 523 + x, 462 + y)
  ctx.quadraticCurveTo(518 + x, 466 + y, 514 + x, 461 + y)
  ctx.quadraticCurveTo(506 + x, 447 + y, 494 + x, 451 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(489 + x, 454 + y)
  ctx.quadraticCurveTo(496 + x, 446 + y, 510 + x, 462 + y)
  ctx.moveTo(491 + x, 447 + y)
  ctx.quadraticCurveTo(515 + x, 439 + y, 524 + x, 452 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  //   // ラベル左上のデザイン
  // ここからハミダシ白
  ctx.beginPath()
  ctx.strokeStyle = '#fff'
  ctx.lineWidth = 2.5
  ctx.moveTo(489 + x, 466 + y)
  ctx.quadraticCurveTo(470 + x, 473 + y, 473 + x, 489 + y)
  ctx.stroke()
  ctx.closePath()
  // ここまでハミダシ白

  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.strokeStyle = state.pitcherDesign.color
  ctx.fillStyle = state.pitcherDesign.color
  ctx.moveTo(489 + x, 468 + y)
  ctx.quadraticCurveTo(474 + x, 474 + y, 474 + x, 489 + y)
  ctx.quadraticCurveTo(484 + x, 478 + y, 484 + x, 478 + y)
  ctx.quadraticCurveTo(480 + x, 473 + y, 489 + x, 468 + y)
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  // stitch
  ctx.beginPath()
  ctx.strokeStyle = state.stitch.color
  ctx.setLineDash([3, 3])
  ctx.moveTo(471 + x, 492 + y) // 左下
  ctx.quadraticCurveTo(460 + x, 483 + y, 480 + x, 466 + y)
  ctx.quadraticCurveTo(487 + x, 461 + y, 499 + x, 462 + y)
  ctx.quadraticCurveTo(485 + x, 474 + y, 487 + x, 477 + y)
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()

  if (numerator !== undefined && scaleSize !== undefined) {
    ctx.restore()
  }
}
